import App from 'app/app.js';
import 'app/directive/LtCyopSummaryCtrl.js';
import template from 'html/cyop/cyop-summary.html';

function LtCyopSummaryDirective($rootScope) {
  return {
    restrict: 'E',
    scope: {
      isScrollable: '=',
      orderLine: '=',
      editIndex: '=',
      onSave: '&',
      onChooseEnhancement: '&',
      isCyopCheckCompleted: '&',
      upgradeOptions: '=',
      hasEmptySheet: '=',
      showAddToCart: '=',
      availableEnhancement: '=',
      subjectContainsStandardPricing: '&'
    },
    template: template,
    link: function (scope, element, attrs, ctrl) {
      scope.onClickSelect = function (index) {
        $rootScope.$emit('on-cyop-choose-item', index);
      };
    },
    controller: 'LtCyopSummaryCtrl',
    controllerAs: 'cyopSummary'
  };
}

App.directive('ltCyopSummary', ['$rootScope', LtCyopSummaryDirective]);
